"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _excluded = ["danger", "nomarginleft"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _ref;
  return _ref = {
    root: function root(props) {
      return {
        fontWeight: 400,
        textTransform: 'none',
        height: '40px',
        boxShadow: 'none',
        marginLeft: props.nomarginleft ? '' : '10px'
      };
    },
    containedPrimary: function containedPrimary(props) {
      return {
        boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
        color: '#fbfbfb',
        '&:hover': {
          boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important'
        }
      };
    }
  }, _defineProperty(_ref, "containedPrimary", function containedPrimary(props) {
    return {
      boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
      color: '#fbfbfb',
      '&:hover': {
        boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important'
      }
    };
  }), _defineProperty(_ref, "outlinedPrimary", function outlinedPrimary(props) {
    return {
      color: theme.palette.primary.main,
      border: 'solid 1px',
      borderColor: theme.palette.primary.main
    };
  }), _defineProperty(_ref, "containedSecondary", function containedSecondary(props) {
    return {
      boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)  !important',
      color: '#fbfbfb',
      '&:hover': {
        boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important'
      }
    };
  }), _defineProperty(_ref, "outlinedSecondary", function outlinedSecondary(props) {
    return {
      color: theme.palette.secondary.main,
      border: 'solid 1px',
      borderColor: theme.palette.secondary.main
    };
  }), _defineProperty(_ref, "disabled", function disabled(props) {
    return {
      color: 'rgba(0, 0, 0, 0.37) !important'
    };
  }), _defineProperty(_ref, "sizeSmall", function sizeSmall(props) {
    return {
      height: '34px'
    };
  }), _ref;
});
var useStylesBtnDanger = (0, _styles.makeStyles)(function (theme) {
  return {
    root: function root(props) {
      return {
        color: '#fbfbfb',
        fontWeight: 400,
        textTransform: 'none',
        height: '40px',
        marginLeft: props.nomarginleft ? '' : '10px',
        backgroundColor: theme.palette.error.main,
        '&:hover': {
          backgroundColor: theme.palette.error.light,
          boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)'
        }
      };
    },
    disabled: {
      color: 'rgba(0, 0, 0, 0.37) !important'
    },
    sizeSmall: {
      height: '34px'
    }
  };
});
function SttButton(props) {
  var danger = props.danger,
    nomarginleft = props.nomarginleft,
    otherProps = _objectWithoutProperties(props, _excluded);
  var classes = useStyles(props);
  var classesDanger = useStylesBtnDanger(props);
  if (danger) {
    return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
      disableRipple: true,
      classes: classesDanger
    }, otherProps));
  }
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    disableRipple: true,
    classes: classes
  }, otherProps));
}
var _default = SttButton;
exports["default"] = _default;